import { useEffect, useState } from 'react';

import {
    getArtDocument,
    getArtDocumentEmbedProvider,
    getArtDocumentMediaType,
    getArtDocumentPlaybackUrl,
    getArtDocumentPreviewUrl,
    getArtDocumentSource,
    isArtDocumentEncodingVideo,
} from '@containers/Art/ArtDocuments';

const useArtDocument = (documentId) => {
    const [document, setDocument] = useState(null);
    const [loading, setLoading] = useState(Boolean(documentId));
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;

        if (!documentId) {
            setDocument(null);
            setLoading(false);
            setError(null);
            return undefined;
        }

        setLoading(true);
        setError(null);

        getArtDocument(documentId)
            .then((nextDocument) => {
                if (cancelled) return;
                setDocument(nextDocument);
            })
            .catch((nextError) => {
                if (cancelled) return;
                setDocument(null);
                setError(nextError);
            })
            .finally(() => {
                if (!cancelled) {
                    setLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [documentId]);

    return {
        document,
        embedProvider: getArtDocumentEmbedProvider(document),
        error,
        isEncodingVideo: isArtDocumentEncodingVideo(document),
        loading,
        mediaType: getArtDocumentMediaType(document),
        playbackUrl: getArtDocumentPlaybackUrl(document),
        previewUrl: getArtDocumentPreviewUrl(document),
        source: getArtDocumentSource(document),
    };
};

export default useArtDocument;
